import { BlotterPreferencePayload } from 'apiConnector/blotters';
import { BaseRowData, BaseRowMetadata } from 'apiConnector/secondary-market/batch/base';
import { IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';
import { RowData } from 'state/workspaces/secondary-market/batch/model';
import { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

export const ORDER_TYPES = ['cp-order', 'ebiz-quote', 'live-quote'] as const;
export type OrderType = (typeof ORDER_TYPES)[number];

export type Row<TData = BaseRowData, TMetadata = BaseRowMetadata> = {
  data: TData;
  metadata: TMetadata;
  query: BcsProductKey;
};

export type SearchResponse = {
  rows: ResponseRowByOrderType[];
};
export type ResponseRowByOrderType = Row<BaseRowData, BaseRowMetadata>;

export type OperationRequest<TData> = {
  rows: TData[];
};

export type OperationResponse = {
  rows: ResponseRowByOrderType[];
};

export type SearchId = {
  code: string;
  source: string;
  subtype?: string;
  id: string;
};
export type SearchRequest = {
  ids: SearchId[];
};

type ModifiedRow<TData> = {
  data: TData;
  modifiedFields: string[];
};

export type ModifyRequest<TData> = { rows: ModifiedRow<TData>[] };

export type DeleteRequest = { rowIds: string[] };
export type ResetRequest = { rowIds: string[] };

export type ReloadResponse = SearchResponse & {
  preference?: BlotterPreferencePayload;
  columnsDefinitions: IBlotterColumnDefinition<RowData>[];
};
